import * as paywallTypes from './paywallTypes';


const initialState = {
  getPaywallList: [],
  tableData: [],
};

const paywallReducer = (state = initialState, action) => {
  switch (action.type) {
    case paywallTypes.GET_PAYWALL_REQUEST_LIST:
      return { ...state, getPaywallList: action.payload.messages};
    // case paywallTypes.RESET_LOBBY_MESSAGE_LIST:
    // return { ...state, ...initialState
    // };
    case paywallTypes.GET_PAYWALL_REQUEST_LOGS:
      return { ...state, tableData: action.payload };
           
    default:
      return state;
  }
};

export { initialState };
export default paywallReducer;
